﻿import * as $ajax from './_ajax'
import * as $modal from './_modal'

export module county {
    export interface IGetListOptions {
        lanId: number;
        onComplete: any;
        fetchAll: boolean;
    }

    export interface IGetListToDropdownOptions {
        lanId: number;
        dropdownElem: JQuery;
        onComplete?: any;
        fetchAll: boolean;
    }

    var fetchJsonOptionDefaults = {
        lanId: 0,
        onComplete: function () { },
        fetchAll: false
    };

    export function getList(options: IGetListOptions) {
        options = <IGetListOptions> $.extend(true, {}, fetchJsonOptionDefaults, options);

        $ajax.post({
            url: "/Geo/CountyGetList",
            data: {
                lanId: options.lanId,
                fetchAll: options.fetchAll
            },
            success: function (res) {
                options.onComplete(res);
            },
            error: function () {
                options.onComplete([]);
            }
        });
    }

    export function getListToDropdown(options: IGetListToDropdownOptions) {
        options = <IGetListToDropdownOptions> $.extend(true, {}, fetchJsonOptionDefaults, options);

        if (options.lanId <= 0 && !options.fetchAll) {
            options.dropdownElem.addSelectOptions([{ Id: -1, Name: "-- Välj län först --" }], "Id", "Name");
            options.dropdownElem.prop("disabled", true);
            options.dropdownElem.trigger("change");
            if (options.onComplete) options.onComplete([]);
            return;
        }

        getList({
            lanId: options.lanId,
            fetchAll: options.fetchAll,
            onComplete: function (list) {
                list.splice(0, 0, { Id: -1, Name: "-- Välj kommun --" });
                options.dropdownElem.addSelectOptions(list, "Id", "Name");
                options.dropdownElem.prop("disabled", false);
                options.dropdownElem.trigger("change");
                if (options.onComplete) options.onComplete(list);
            }
        });
    }
}

export module regionsmapforsearch {
    export interface IInitOptions {
        pageName: string;
        pagePrefix: string;
        pagePrefixParent: string;
        multi: boolean;
    }

    export function init(options:IInitOptions) : void {
        $("." + options.pagePrefix + "-regions-region--active").click(function () {
            var id:string = $(this).attr("data-id");

            $(this).toggleClass("selected");

            var selected = $(this).hasClass("selected");

            if (options.multi) {
                if (selected) $("#" + options.pagePrefixParent + "-regionmulti-searchresult-list li.d" + id + " .icon--add").trigger("click");
                else $("#" + options.pagePrefixParent + "-regionmulti-searchfor-list li.d" + id + " .icon--add").trigger("click");
            } else {
                if (selected) {
                    $("#" + options.pagePrefixParent + "-region").val(id);
                    $("#" + options.pagePrefixParent + "-region").trigger("change");
                    $modal.hide();
                }
                // else should not be able to happen
            }
        });
    }
}

export module countymapforsearch {
    export interface IInitOptions {
        pageName: string;
        pagePrefix: string;
        pagePrefixParent: string;
        multi: boolean;
    }

    export function init(options:IInitOptions) : void {
        $("." + options.pagePrefix + "-counties-county").click(function () {
            var id:string = $(this).attr("data-id");

            $(this).toggleClass("selected");

            var selected = $(this).hasClass("selected");

            if (options.multi) {
                if (selected) $("#" + options.pagePrefixParent + "-countymulti-searchresult-list li.d" + id + " .icon--add").trigger("click");
                else $("#" + options.pagePrefixParent + "-countymulti-searchfor-list li.d" + id + " .icon--add").trigger("click");
            } else {
                if (selected) {
                    $("#" + options.pagePrefixParent + "-county").val(id);
                    $("#" + options.pagePrefixParent + "-county").trigger("change");
                    $modal.hide();
                }
                // else should not be able to happen
            }
        });
    }
}

export module districtmapforsearch {
    export interface IInitOptions {
        pageName: string;
        pagePrefix: string;
        pagePrefixParent: string;
    }

    export function init(options:IInitOptions) : void {
        $("." + options.pagePrefix + "-districts-district").click(function () {
            var id:string = $(this).attr("data-id");

            $(this).toggleClass("selected");

            var selected = $(this).hasClass("selected");
            if (selected) $("#" + options.pagePrefixParent + "-district-searchresult-list li.d" + id + " .icon--add").trigger("click");
            else $("#" + options.pagePrefixParent + "-district-searchfor-list li.d" + id + " .icon--add").trigger("click");
        });
    }
}